import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const REPEAT = 10;
const TEXT_UNIT = "IF IT HAS WHEELS WE MAKE IT SHINE / BIZZY DETAILS / ";
export function MarqueeKinetic() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!sectionRef.current || !textRef.current) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const ctx = gsap.context(() => {
      gsap.to(textRef.current, {
        xPercent: -15,
        ease: "none",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top bottom",
          end: "bottom top",
          scrub: 1.5,
        },
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <div
      ref={sectionRef}
      style={{
        position: "relative",
        overflow: "hidden",
        background: "#000",
        /* Math: stripe_height + viewport_width * tan(6°) ≈ 110 + 151 = 261px minimum */
        height: 300,
      }}
    >
      {/* Diagonal marquee stripe */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "-10%",
          width: "120%",
          height: 110,
          background: "#1E5EFF",
          transform: "translateY(-50%) rotate(-6deg)",
          display: "flex",
          alignItems: "center",
          overflow: "hidden",
          zIndex: 10,
        }}
      >
        <span
          ref={textRef}
          style={{
            display: "block",
            whiteSpace: "nowrap",
            fontFamily: "var(--font-display)",
            fontWeight: 900,
            fontStyle: "italic",
            fontSize: "clamp(1.1rem, 2vw, 1.8rem)",
            textTransform: "uppercase",
            letterSpacing: "0.25em",
            color: "#000",
            willChange: "transform",
          }}
        >
          {Array(REPEAT).fill(TEXT_UNIT).join("")}
        </span>
      </div>
    </div>
  );
}
